import React, { useState } from "react"
import { IoMdCheckmarkCircle } from "react-icons/io"
import Ratings from "react-ratings-declarative"
import ReCAPTCHA from "react-google-recaptcha"
import { motion } from "framer-motion"

const ReviewForm = ({ setReviews, reviews, productId }) => {
  // take all this state to product-page-components.js
  const [error, setError] = useState("")
  const [rating, setRating] = useState(0)
  const [name, setName] = useState("")
  const [review, setReview] = useState("")
  const [formOpen, setFormOpen] = useState(false)
  const [captchaToken, setCaptchaToken] = useState(null)
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)

  const variants = {
    visible: { opacity: 1, height: "100%" },
    hidden: { opacity: 0, height: 0 },
  }

  const rate = rating => {
    if (!formOpen) {
      setFormOpen(true)
    }
    setRating(rating)
  }

  const submit = async e => {
    e.preventDefault()
    if (rating === 0) {
      setError("Please add a score!")
      return
    }
    if (captchaToken === null) {
      setError("Please verify you are human.")
      return
    }
    setLoading(true)
    const comment = {
      name,
      token: captchaToken,
      review,
      rating,
      productId,
    }
    const response = await fetch(
      `${process.env.GATSBY_API_BASE_URL}api/comment`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(comment),
      }
    )
    if (response.status === 200) {
      const data = await response.json()
      setLoading(false)
      setDone(true)
      setReviews([data, ...reviews])
    } else {
      setError("An error occured. Please try again later.")
      setLoading(false)
      setDone(false)
    }
  }

  return (
    <>
      {loading && !done && (
        <div className="review__set-score" style={{ minHeight: 99 }}>
          <div
            style={{ top: 45, fontSize: 10 }}
            className="loader is-loading"
          ></div>
        </div>
      )}
      {!loading && done && (
        <div className="review__set-score completed">
          <IoMdCheckmarkCircle className="complete__icon" />
        </div>
      )}
      {!loading && !done && (
        <>
          <div className="review__set-score is-hidden-desktop">
            <p className="review__set-score--title">
              How was your taste experience?
            </p>
          </div>
          <div className="review__set-score">
            <p
              className="review__set-score--title is-hidden-touch"
              style={{ marginBottom: 35 }}
            >
              How was your taste experience?
            </p>
            <div className="review__set-score--stars">
              <Ratings
                rating={rating}
                widgetRatedColors="blue"
                changeRating={rate}
              >
                <Ratings.Widget
                  widgetDimension="40px"
                  widgetHoverColor="#2b4158"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="40px"
                  widgetHoverColor="#2b4158"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="40px"
                  widgetHoverColor="#2b4158"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="40px"
                  widgetHoverColor="#2b4158"
                  widgetRatedColor="#1a1a38"
                />
                <Ratings.Widget
                  widgetDimension="40px"
                  widgetHoverColor="#2b4158"
                  widgetRatedColor="#1a1a38"
                />
              </Ratings>
            </div>
          </div>

          {!done && !loading && formOpen && (
            <div className="review__set-score">
              <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
              >
                <form className="form" onSubmit={submit}>
                  <div className="columns is-multiline">
                    <div className="column is-12">
                      <div className="input-group">
                        <label className="label">Name</label>
                        <input
                          value={name}
                          onChange={e => setName(e.target.value)}
                          name="firstname"
                          type="text"
                          className="input"
                        />
                      </div>
                    </div>
                    <div className="column is-12">
                      <div className="input-group">
                        <label className="label">Review</label>
                        <textarea
                          value={review}
                          onChange={e => setReview(e.target.value)}
                          className="input input__textarea"
                          cols="20"
                        ></textarea>
                      </div>
                    </div>
                    <div className="column is-12">
                      <div className="input-group">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <ReCAPTCHA
                            sitekey="6LdRG9AZAAAAAKIny0l4VKf5GPX53g6PF1eldtpx"
                            onChange={setCaptchaToken}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="button">
                    Send Review
                  </button>
                  {error && (
                    <p style={{ color: "#e52329", marginTop: 10 }}>{error}</p>
                  )}
                </form>
              </motion.div>
            </div>
          )}
        </>
      )}
    </>
  )
}

const equal = (prev, next) => true

export default React.memo(ReviewForm, equal)
